import request from "@/http";

/**
 * 发送手机验证码
 * @param {手机号} user_phone
 * @param {是否加载} isloading
 * @returns
 */
const sendPhoneCode = (data) => {
  let {user_phone, pic_code, isloading = false} = data;
  return request.post({
    url: "duzikai_api_customer_public_global_mgr",
    data: {
      invoke_method: "send_msg_phone",
      user_phone: user_phone,
      pre_cmd_para_need_pic_code: true,
      pre_cmd_para_db_exist_user: false,
      id_public_data_admin_user: 800,
      pic_code: pic_code,
    },
    loading: {
      enabled: isloading,
    },
  });
};

const sendPhoneCodeByNoPic = (data) => {
  let {user_phone, isloading = false} = data;
  return request.post({
    url: "duzikai_api_customer_public_global_mgr",
    data: {
      invoke_method: "send_msg_phone",
      user_phone: user_phone,
      pre_cmd_para_need_pic_code: false,
      pre_cmd_para_db_exist_user: false,
      id_public_data_admin_user: 800,
    },
    loading: {
      enabled: isloading,
    },
  });
};

/**
 *
 * @param {手机号} user_phone
 * @param {短信验证码} msg_content
 * @param {图片验证码} pic_code
 * @returns
 */
const phoneCodeLogin = (data) => {
  let {user_phone, msg_content, pic_code, isloading = false} = data;
  return request.post({
    url: "duzikai_api_customer_public_global_mgr",
    data: {
      invoke_method: "login_by_phone_code",
      user_phone: user_phone,
      pre_cmd_para_msg_content: msg_content,
      pre_cmd_para_need_pic_code: false
    },
    loading: {
      enabled: isloading,
    },
  });
};
/**
 *
 * @param {手机号} user_phone
 * @param {密码} password_user
 * @param {图片验证码} pic_code
 * @returns
 */
const pwdLogin = (data) => {
  let {user_phone, password_user, pic_code, isloading = false} = data;
  return request.post({
    url: "duzikai_api_customer_public_global_mgr",
    data: {
      invoke_method: "login_by_password",
      user_phone: user_phone,
      password_user: password_user,
      pic_code: pic_code,
      pre_cmd_para_need_pic_code: true,
    },
    loading: {
      enabled: isloading,
    },
  });
};
const sysUserpwdLogin = (data) => {
  let {user_phone, password_user, isloading = false} = data;
  return request.post({
    url: "duzikai_api_customer_public_global_mgr",
    data: {
      invoke_method: "login_by_password",
      user_phone: user_phone,
      password_user: password_user,
      pre_cmd_para_need_pic_code: false,
    },
    loading: {
      enabled: isloading,
    },
  });
};
// 获取用户信息
const getUserShopInfo = (data) => {
  let {isloading = false} = data;
  return request.get({
    url: "duzikai_api_customer_public_base_info_mgr",
    data: {
      invoke_method: "user_and_shop_info",
    },
    loading: {
      enabled: isloading,
    },
  });
};

/**
 * 注册账号，基础信息
 * @param {手机号} user_phone
 * @param {密码} password_user
 * @param {图片验证码} pic_code
 * @param {短信验证码} msg_content
 * @returns
 */
const registerUser = (data) => {
  let {
    user_phone,
    password_user,
    pic_code,
    msg_content,
    isloading = false,
  } = data;
  return request.post({
    url: "duzikai_api_customer_public_global_mgr",
    data: {
      invoke_method: "register_user",
      user_phone: user_phone,
      password_user: password_user,
      pic_code: pic_code,
      msg_content: msg_content,
    },
    loading: {
      enabled: isloading,
    },
  });
};
/**
 *
 * @param {用户id} id_public_user_info
 * @param {用户昵称} nick_name
 * @param {用户类型} user_remark_001
 * @param {用户身份} user_remark_002
 * @param {用户身份备注} user_remark_009
 * @param {开发语言} user_remark_003
 * @param {开发语言备注} user_remark_010
 * @param {用户来源} user_remark_004
 * @param {公司名称} user_remark_005
 * @param {团队人数} user_remark_006
 * @param {开发地} user_remark_007
 * @param {行业} user_remark_008
 * @param {行业备注} user_remark_011
 * @param {营业执照} user_remark_019
 * @param {粉丝量} user_remark_021
 * @param {涉猎领域} user_remark_022
 * @param {涉猎领域备注} user_remark_023
 * @param {用户邮箱} user_email
 * @param {用户上线} upline_id_user
 * @returns
 */
const changeUerInfo = (data) => {
  let {
    id_public_user_info,
    nick_name,
    user_remark_001,
    user_remark_002,
    user_remark_009,
    user_remark_003,
    user_remark_010,
    user_remark_004,
    user_remark_005,
    user_remark_006,
    user_remark_007,
    user_remark_008,
    user_remark_011,
    user_remark_019,
    user_remark_021,
    user_remark_022,
    user_remark_023,
    user_email,
    upline_id_user,
    isloading = false,
  } = data;
  return request.post({
    url: "duzikai_api_mgr_public_user_info",
    data: {
      invoke_method: "change_user_info",
      pre_db_para_id_public_user_info: id_public_user_info,
      nick_name: nick_name,
      user_remark_001: user_remark_001,
      user_remark_002: user_remark_002,
      user_remark_009: user_remark_009,
      user_remark_003: user_remark_003,
      user_remark_010: user_remark_010,
      user_remark_004: user_remark_004,
      user_remark_005: user_remark_005,
      user_remark_006: user_remark_006,
      user_remark_007: user_remark_007,
      user_remark_008: user_remark_008,
      user_remark_011: user_remark_011,
      user_remark_019: user_remark_019,
      user_remark_021: user_remark_021,
      user_remark_022: user_remark_022,
      user_remark_023: user_remark_023,
      user_email: user_email,
      upline_id_user: upline_id_user,
    },
    loading: {
      enabled: isloading,
    },
  });
};
const changeUerInfoAvatar = (data) => {
  let {id_public_user_info, weichat_img, isloading = false} = data;
  return request.post({
    url: "duzikai_api_mgr_public_user_info",
    data: {
      invoke_method: "change_user_info",
      pre_db_para_id_public_user_info: id_public_user_info,
      weichat_img: weichat_img,
    },
    loading: {
      enabled: isloading,
    },
  });
};
/**
 * 忘记密码
 * @param {手机号} user_phone
 * @param {短信验证码} msg_content
 * @param {图片验证码} pic_code
 * @param {密码} password_user
 * @param {是否加载} isloading
 * @returns
 */
const forgetPassword = (data) => {
  let {user_phone, msg_content, password_user, isloading = false} = data;
  return request.post({
    url: "duzikai_api_customer_public_global_mgr",
    data: {
      invoke_method: "forget_password",
      user_phone: user_phone,
      msg_content: msg_content,
      pre_cmd_para_need_pic_code: false,
      password_user: password_user,
    },
    loading: {
      enabled: isloading,
    },
  });
};

/**
 * 修改账户安全密码
 * @param {手机号} user_phone
 * @param {短信验证码} msg_content
 * @param {图片验证码} pic_code
 * @param {密码} password_user
 * @param {是否加载} isloading
 * @returns
 */
const searchUserByPhone = (data) => {
  let {user_phone, isloading = false} = data;
  return request.post({
    url: "duzikai_api_mgr_public_user_info",
    data: {
      invoke_method: "public_page_4m_load_user_list",
      user_phone: user_phone,
      pre_db_para_begin_idx: 0,
      pre_db_para_length_4_list: 10,
    },
    loading: {
      enabled: isloading,
    },
  });
}
const changePhoneUser = (data) => {
  let {user_phone, msg_content, pic_code, isloading = false} = data;
  return request.post({
    url: "duzikai_api_customer_public_global_mgr",
    data: {
      invoke_method: "change_phone",
      user_phone: user_phone,
      pre_cmd_para_msg_content: msg_content,
      pre_cmd_para_pic_code: pic_code,
    },
    loading: {
      enabled: isloading,
    },
  });
};
const centerChangeUserPwd = (data) => {
  let {
    user_phone,
    msg_content,
    pic_code,
    password_user,
    isloading = false,
  } = data;
  return request.post({
    url: "duzikai_api_customer_public_global_mgr",
    data: {
      invoke_method: "forget_password",
      user_phone: user_phone,
      msg_content: msg_content,
      pre_cmd_para_need_pic_code: false,
      password_user: password_user,
      pre_cmd_para_pic_code: pic_code,
    },
    loading: {
      enabled: isloading,
    },
  });
};

export default {
  sendPhoneCode,
  phoneCodeLogin,
  pwdLogin,
  sysUserpwdLogin,
  getUserShopInfo,
  registerUser,
  changeUerInfo,
  changeUerInfoAvatar,
  forgetPassword,
  changePhoneUser,
  centerChangeUserPwd,
  searchUserByPhone,
  sendPhoneCodeByNoPic
};
